import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

export const {
  GridSharedStyles: {
    getSharedBodyStyles,
    getSharedColGroupStyles,
    getSharedColumnsStyles,
    getSharedFooterStyles,
    getSharedGlobalStyles,
    getSharedHeaderStyles,
    getSharedTableStyles,
    variables,
  },
} = ComponentSettings;
